import { useState, useEffect } from 'react'
import './mangluoi.scss'
import { Table } from 'antd'
import Loading from '../../../../../component/Loading/Loading'

const MangluoiLayout = ({ userdata, datanguoi }) => {
  const [data, setData] = useState([])
  const [activeTab, setActiveTab] = useState('all')
  const [isLoading, setIsLoading] = useState(true)
  const apiUrl = process.env.REACT_APP_API_BACKEND

  const fetchData = async (type) => {
    setIsLoading(true)
    try {
      const response = await fetch(
        `${apiUrl}/getfulluserdaily/${userdata.id}?type=${type}`
      )
      const result = await response.json()
      if (response.ok) {
        setData(result)
      } else {
        setData([])
      }
    } catch (error) {
      console.error(error)
      setData([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (userdata?.id) {
      fetchData(activeTab)
    }
  }, [userdata, activeTab])

  const tabOptions = [
    { label: `ทั้งหมด`, value: 'all' },
    { label: `Lv1`, value: 'f1' },
    { label: `Lv2`, value: 'f2' },
    { label: `Lv3`, value: 'f3' }
  ]

  const columns = [
    {
      title: 'ชื่อผู้ใช้',
      dataIndex: 'userdangky',
      key: 'username',
    },
    {
      title: 'Level',
      dataIndex: 'level',
      key: 'level',
      render: (level) => level?.toUpperCase()
    },
    {
      title: 'ยอดคงเหลือ',
      dataIndex: 'coin',
      key: 'coin',
      render: (coin) => Number((coin || 0).toFixed(0)).toLocaleString('en-US')
    },
    {
      title: 'วันที่สมัคร',
      dataIndex: 'created',
      key: 'created',
    }
  ]

  return (
    <div className='transaction-container'>
      {/* Hiển thị tổng số từ datanguoi */}
      <div className='team-summary'>
        <span>F1: {datanguoi?.f1 || 0}</span>
        <span>F2: {datanguoi?.f2 || 0}</span>
        <span>F3: {datanguoi?.f3 || 0}</span>
      </div>

      {/* Tabs */}
      <div className='tabs-daily-team'>
        {tabOptions.map(tab => (
          <button
            key={tab.value}
            className={`tab-button-daily-team ${activeTab === tab.value ? 'active-daily-team' : ''}`}
            onClick={() => setActiveTab(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Bảng */}
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record, index) => index}
        loading={isLoading}
        pagination={{ pageSize: 10 }}
        locale={{ emptyText: 'ไม่มีข้อมูล' }}
      />

      {/* Loading overlay (nếu muốn) */}
      <Loading isLoading={isLoading} />
    </div>
  )
}

export default MangluoiLayout
